// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.invalid {
    border-bottom: 1px solid red;
}

.limitMessage {
    position: absolute;
    right: 10px;
    bottom: 3px;
    font-size: small;
}`, "",{"version":3,"sources":["webpack://./src/app/components/controls/translationtextbox/translation.textbox.component.css"],"names":[],"mappings":"AAAA;IACI,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,gBAAgB;AACpB","sourcesContent":[".invalid {\n    border-bottom: 1px solid red;\n}\n\n.limitMessage {\n    position: absolute;\n    right: 10px;\n    bottom: 3px;\n    font-size: small;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
